let isProcessing = false;
const API_ENDPOINT = 'https://hmjfdzxho8.execute-api.us-east-1.amazonaws.com/dev/create-draft-order';

const getQuoteButton = () => document.querySelector('#quote-btn') || 
                             document.querySelector('.cart__quote-button') ||
                             document.querySelector('[data-quote-btn]');

const getCustomerEmail = () => {
  return window.shopifyCustomer?.email || 
         window.customer?.email || 
         Shopify?.customer?.email || 
         null;
};

const getCartData = async () => {
  try {
    const response = await fetch('/cart.js');
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    
    return await response.json();
  } catch (error) {
    console.error('Error obteniendo datos del carrito:', error);
    return null;
  }
};

const preparePayload = (cartData) => {
  const customerEmail = getCustomerEmail();
  
  const lineItems = cartData.items.map(item => ({
    variantId: item.variant_id,
    quantity: item.quantity,
    price: item.price / 100, // Precio original de Shopify
    title: item.product_title,
    variantTitle: item.variant_title,
    sku: item.sku,
    vendor: item.vendor,
    properties: item.properties || {}
  }));

  return {
    customerEmail,
    lineItems,
    cartData: { 
      totalPrice: cartData.total_price / 100,
      itemCount: cartData.item_count,
      currency: cartData.currency || 'CLP',
      note: cartData.note || '',
      cartLevelDiscountApplications: cartData.cart_level_discount_applications || []
    },
    createdAt: new Date().toISOString(),
    source: 'wholesale_quote'
  };
};

const sendToAPI = async (payload) => {
  const response = await fetch(API_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(payload)
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`HTTP ${response.status}: ${errorText}`);
  }

  return await response.json();
};

const showLoading = () => {
  const button = getQuoteButton();
  
  if (button) {
    button.disabled = true;
    button.innerHTML = 'Creando cotización y enviando PDF...';
  }
};

const hideLoading = () => {
  const button = getQuoteButton();
  
  if (button) {
    button.disabled = false;
    button.innerHTML = 'COTIZAR';
  }
};

const showSuccess = (draftOrder) => {
  let message = '¡Cotización creada exitosamente!\n\n';
  
  if (draftOrder.id && draftOrder.id !== 'N/A') {
    message += `ID: ${draftOrder.id}\n`;
  }
  
  if (draftOrder.name && draftOrder.name !== 'N/A') {
    message += `Número: ${draftOrder.name}\n`;
  }
  
  if (draftOrder.totalPrice && draftOrder.totalPrice !== 'N/A') {
    message += `Total: ${draftOrder.totalPrice} ${draftOrder.currency || ''}\n`;
  }
  
  if (draftOrder.email && draftOrder.email !== 'N/A') {
    message += `Email: ${draftOrder.email}\n`;
  }
  
  if (draftOrder.lineItemsCount > 0) {
    message += `Productos: ${draftOrder.lineItemsCount} items\n`;
  }
  
  message += '\nSe ha enviado la cotización y PDF a tu email para revisión.';
  
  if (draftOrder.invoiceUrl && draftOrder.invoiceUrl !== 'N/A') {
    message += `\n\nPuedes ver la cotización en: ${draftOrder.invoiceUrl}`;
  }

  alert(message);
};

const showError = (errorMessage) => {
  alert(`Error al crear la cotización:\n\n${errorMessage}\n\nPor favor intenta de nuevo o contacta soporte.`);
};

const trackDraftOrderCreated = (draftOrderData) => {
  try {
    if (typeof gtag !== 'undefined') {
      gtag('event', 'draft_order_created', {
        'draft_order_id': draftOrderData.id,
        'cart_value': draftOrderData.totalPrice,
        'items_count': draftOrderData.lineItemsCount || 0
      });
    }
    
    const orderHistory = JSON.parse(localStorage.getItem('draft_orders_history') || '[]');
    orderHistory.unshift({
      id: draftOrderData.id,
      created_at: new Date().toISOString(),
      total: draftOrderData.totalPrice
    });
    localStorage.setItem('draft_orders_history', JSON.stringify(orderHistory.slice(0, 10)));
    
  } catch (error) {
    console.log('Error en tracking:', error);
  }
};

const createDraftOrder = async () => {
  if (isProcessing) return;
  
  try {
    isProcessing = true;
    showLoading();
    
    const cartData = await getCartData();
    
    if (!cartData || cartData.items.length === 0) {
      alert('El carrito está vacío');
      return;
    }
    
    const payload = preparePayload(cartData);
    
    if (!payload.customerEmail) {
      alert('Debes estar logueado para crear una cotización.\n\nPor favor inicia sesión e intenta de nuevo.');
      return;
    }
    
    const response = await sendToAPI(payload);
    
    if (response.success) {
      showSuccess(response.draftOrder);
      trackDraftOrderCreated(response.draftOrder);
      
      try {
        if (window.PDFFrontGenerator && typeof window.PDFFrontGenerator.sendPDFQuote === 'function') {
          // ✅ Usamos cartDataWithWPD que viene del backend con precios wholesale
          const cartDataForPDF = response.cartDataWithWPD || cartData;
          await window.PDFFrontGenerator.sendPDFQuote(cartDataForPDF, response.draftOrder, payload.customerEmail);
          console.log('PDF enviado exitosamente');
        } else {
          throw new Error('PDFFront.js no está cargado');
        }
      } catch (pdfError) {
        console.error('Error enviando PDF:', pdfError);
        alert('Cotización creada exitosamente, pero hubo un problema enviando el PDF por email.');
      }
    } else {
      throw new Error(response.error || 'Error desconocido');
    }
    
  } catch (error) {
    showError(error.message);
  } finally {
    isProcessing = false;
    hideLoading();
  }
};

const handleClick = (e) => {
  if (e.target.textContent.trim() === 'COTIZAR' || e.target.id === 'quote-btn') {
    e.preventDefault();
    e.stopPropagation();
    createDraftOrder();
  }
};

const init = () => {
  document.addEventListener('click', handleClick);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}